// Components
import AppIcon from 'Ui/AppIcon'
import AppInput from 'Ui/AppInput'
import AppHeading from 'Ui/AppHeading'
import AppForm from 'Components/AppForm'
import AppRouterLink from 'Ui/AppRouterLink'
import SubmitButtonMagenta from 'Components/SubmitButtonMagenta'

export default {
  components: {
    AppIcon,
    AppForm,
    AppInput,
    AppHeading,
    AppRouterLink,
    SubmitButtonMagenta,
  },

  data() {
    return {
      sendingData: false,
    }
  },

  methods: {
    toggleSendingData() {
      this.sendingData = !this.sendingData
    },
  },
}
